import api from "../config/api";

export const fetchAllComment = async () => {
  const res = await api.get("/comments/");
  return res.data.data;
 
  
};

export const fetchCommentById = (commentId) => {
  const res = api.get(`/comments/${commentId}`);
};

export const createComment = async (postData) => {
  const res = await api.post(`/comments/`, postData);
  return res.data;
};

export const updateComment = async (commentId, postData) => {
  const res = await api.put(`/comments/?id=${commentId}`, postData);
  return res.data;
};

export const deleteComment = async (commentId) => {
  const res = await api.delete(`/comments/?id=${commentId}`);
  return res.data;
};
